(() => {
  const rawRoot = String(window.LoubnaLocaleRoot || '/').trim();
  const localeRoot = rawRoot === '/' ? '' : rawRoot.replace(/\/$/, '');
  const isArabic = (document.documentElement.lang || '').toLowerCase().startsWith('ar');
  document.documentElement.dir = isArabic ? 'rtl' : 'ltr';

  function fixLocaleSpecificCopy(scope = document) {
    if (isArabic) return;
    const essentialLabel = scope.querySelector?.('.loubna-writer-form__tier input[value="essentiel"] + .loubna-writer-form__tier-card > strong');
    if (essentialLabel && essentialLabel.textContent.trim() === 'Essentiel') {
      essentialLabel.textContent = 'Essential';
    }
  }

  function fixDocumentTitle() {
    if (!isArabic || !document.title) return;
    document.title = document.title
      .replace(/\s+[–-]\s+tagged\s+"/i, ' – موسوم بـ "')
      .replace(/\s+[–-]\s+Page\s+(\d+)/i, ' – الصفحة $1');
  }

  function fixHeroA11y(scope = document) {
    if (!isArabic) return;
    scope.querySelectorAll?.('.loubna-maquette__dots [data-dot][aria-label]').forEach((button) => {
      const match = button.getAttribute('aria-label')?.match(/^Slide\s+(\d+)$/i);
      if (match) button.setAttribute('aria-label', `الشريحة ${match[1]}`);
    });
  }

  function runCopyFixes() {
    fixLocaleSpecificCopy();
    fixDocumentTitle();
    fixHeroA11y();
  }

  if (!localeRoot) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runCopyFixes, { once: true });
    } else {
      runCopyFixes();
    }
    return;
  }

  const localizedPrefix = new RegExp(`^${localeRoot.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(?:/|$)`);
  const otherLocalePrefix = /^\/(?:ar|en)-dz(?:\/|$)/i;
  const localizablePath = /^\/(?:collections(?:\/|$)|products(?:\/|$)|pages(?:\/|$)|blogs(?:\/|$)|search(?:\/|$))/i;

  function localizeHref(anchor) {
    const href = anchor.getAttribute('href');
    if (!href || !href.startsWith('/') || href.startsWith('//')) return;
    if (!localizablePath.test(href)) return;
    if (localizedPrefix.test(href) || otherLocalePrefix.test(href)) return;
    anchor.setAttribute('href', `${localeRoot}${href}`);
  }

  function localizeAll(scope = document) {
    scope.querySelectorAll('a[href^="/"]').forEach(localizeHref);
  }

  const run = () => {
    localizeAll();
    fixLocaleSpecificCopy();
    fixDocumentTitle();
    fixHeroA11y();
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches?.('a[href^="/"]')) localizeHref(node);
          localizeAll(node);
          fixLocaleSpecificCopy(node);
          fixHeroA11y(node);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
